export default __webpack_public_path__ + "static/media/pirate2.31b1d617.png";